import { hasProductPackages } from '../../lib/package-utils.js'
export const ROI_PARAM_KEYS = {
  PID: 'pid',
  COUNTRY: 'country',
  START_DATE: 'startDate',
  END_DATE: 'endDate',
  PACKAGE_NAME: 'packageName',
}

const DATE_REGEX = /^\d{8}$/

export function isValidDateParam(value) {
  if (!value || !DATE_REGEX.test(value)) return false
  const month = parseInt(value.slice(4, 6), 10)
  const day = parseInt(value.slice(6, 8), 10)
  return month >= 1 && month <= 12 && day >= 1 && day <= 31
}

export function parseRoiUrlParams(searchParams) {
  const pidRaw = searchParams.get(ROI_PARAM_KEYS.PID)
  const countryRaw = searchParams.get(ROI_PARAM_KEYS.COUNTRY)
  const startDateRaw = searchParams.get(ROI_PARAM_KEYS.START_DATE)
  const endDateRaw = searchParams.get(ROI_PARAM_KEYS.END_DATE)
  const packageNameRaw = searchParams.get(ROI_PARAM_KEYS.PACKAGE_NAME)

  const pids = pidRaw ? pidRaw.split(',').filter(Boolean) : []
  const countries = countryRaw ? countryRaw.split(',').filter(Boolean) : []

  const startDate = isValidDateParam(startDateRaw) ? startDateRaw : null
  const endDate = isValidDateParam(endDateRaw) ? endDateRaw : null

  const result = { pids, countries, startDate, endDate }

  if (hasProductPackages(pids.join(',')) && packageNameRaw) {
    result.packageName = packageNameRaw
  }

  return result
}

export function serializeRoiUrlParams({
  pids,
  countries,
  startDate,
  endDate,
  packageName,
}) {
  const params = new URLSearchParams()

  if (pids?.length) {
    params.set(ROI_PARAM_KEYS.PID, pids.join(','))
  }

  if (countries?.length) {
    params.set(ROI_PARAM_KEYS.COUNTRY, countries.join(','))
  }

  if (startDate && isValidDateParam(startDate)) {
    params.set(ROI_PARAM_KEYS.START_DATE, startDate)
  }
  if (endDate && isValidDateParam(endDate)) {
    params.set(ROI_PARAM_KEYS.END_DATE, endDate)
  }

  if (hasProductPackages((pids || []).join(',')) && packageName) {
    params.set(ROI_PARAM_KEYS.PACKAGE_NAME, packageName)
  }

  return params
}

export function hasRoiUrlParams(searchParams) {
  return Object.values(ROI_PARAM_KEYS).some((key) => searchParams.has(key))
}
